import React from 'react';

import * as S from './styles';

export type ToastType = 'info' | 'success' | 'warning' | 'error';
type Props = {
  children: React.ReactNode;
  type: ToastType;
};

const ToastMessage = ({ children, type }: Props) => {
  let icon = null;
  const iconSize = 24;
  switch (type) {
    case 'info':
      icon = <S.Info size={iconSize} color="maybeBlue700" />;
      break;
    case 'success':
      icon = <S.Check size={iconSize} color="positive700" />;
      break;
    case 'warning':
    case 'error':
      icon = <S.Warning size={iconSize} color="redio700" />;
      break;
    default:
  }

  return (
    <S.Message>
      {icon}
      {children}
    </S.Message>
  );
};

export default ToastMessage;
